import React from 'react';
import {
  Card,
  CardHeaderNumber,
} from './MetricsCard';
import * as Price from '../util/Price';

export default function UpcomingRevenueCard({ metrics }) {
  // upcomingRevenue now contains the final amount per organization (after applying minimum monthly charges)
  // Each organization's amount is max(calculatedCharges, minMonthlyCharges), then summed
  return (
    <Card xswidth="100%" title="Upcoming Revenue">
      <CardHeaderNumber>{Price.CurrencyFormatter((Price.output(metrics.upcomingRevenue, true)))}</CardHeaderNumber>
    </Card>
  );
}
